import { render, staticRenderFns } from "./AuthRegister.vue?vue&type=template&id=e7feb808&"
import script from "./AuthRegister.vue?vue&type=script&lang=js&"
export * from "./AuthRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7feb808')) {
      api.createRecord('e7feb808', component.options)
    } else {
      api.reload('e7feb808', component.options)
    }
    module.hot.accept("./AuthRegister.vue?vue&type=template&id=e7feb808&", function () {
      api.rerender('e7feb808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthRegister.vue"
export default component.exports